import React, { useEffect, useState } from 'react';
import { FaClipboardCheck, FaPrint, FaQrcode } from 'react-icons/fa';
import { apiBaseUrl, bookAPI, distributionAPI, schoolAPI } from '../../utils/api';

const emptyItem = { bookId: '', quantity: '' };

export default function SchoolHandoversPage() {
  const [rows, setRows] = useState([]);
  const [schools, setSchools] = useState([]);
  const [books, setBooks] = useState([]);
  const [schoolId, setSchoolId] = useState('');
  const [items, setItems] = useState([{ ...emptyItem }]);
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const [handoverRes, schoolRes, bookRes] = await Promise.all([
        distributionAPI.handovers.list(),
        schoolAPI.getAll(),
        bookAPI.getAll(),
      ]);
      setRows(handoverRes.data?.content || []);
      setSchools(schoolRes.data?.content || schoolRes.data || []);
      setBooks(bookRes.data?.content || bookRes.data || []);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const setItem = (index, patch) => {
    setItems(prev => prev.map((item, i) => i === index ? { ...item, ...patch } : item));
  };

  const submit = async e => {
    e.preventDefault();
    const cleanItems = items
      .map(item => ({ bookId: Number(item.bookId), quantity: Number(item.quantity) }))
      .filter(item => item.bookId && item.quantity > 0);
    if (!schoolId || !cleanItems.length) {
      setError('Select school and add at least one item.');
      return;
    }
    try {
      const res = await distributionAPI.handovers.create({ schoolId: Number(schoolId), items: cleanItems, remarks });
      setSchoolId('');
      setItems([{ ...emptyItem }]);
      setRemarks('');
      await load();
      window.open(`${apiBaseUrl}/api/v1/distribution/handovers/${res.data.id}/receipt`, '_blank');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };

  return (
    <div className="eduss-dashboard">
      <div className="eduss-dashboard-welcome">
        <h1>Head Master Handovers</h1>
        <p>Issue books to assigned schools and print QR acknowledgement receipts for head masters.</p>
      </div>

      <div className="eduss-dashboard-cards-row">
        <div className="eduss-dashboard-card eduss-dashboard-card-green">
          <div className="eduss-dashboard-card-icon"><FaClipboardCheck /></div>
          <div className="eduss-dashboard-card-content"><div className="eduss-dashboard-card-label">Handovers</div><div className="eduss-dashboard-card-value">{loading ? '...' : rows.length}</div></div>
        </div>
        <div className="eduss-dashboard-card eduss-dashboard-card-blue">
          <div className="eduss-dashboard-card-icon"><FaQrcode /></div>
          <div className="eduss-dashboard-card-content"><div className="eduss-dashboard-card-label">Acknowledged</div><div className="eduss-dashboard-card-value">{rows.filter(r => r.status === 'ACKNOWLEDGED').length}</div></div>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="eduss-dashboard-content">
        <h2>New Handover</h2>
        <form onSubmit={submit}>
          <select className="form-control mb-3" value={schoolId} onChange={e => setSchoolId(e.target.value)}>
            <option value="">Select assigned school</option>
            {schools.map(school => (
              <option key={school.id} value={school.id}>{school.name || school.school_name || `School #${school.id}`}</option>
            ))}
          </select>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'grid', gridTemplateColumns: '1fr 140px 120px', gap: 12, marginBottom: 10 }}>
              <select className="form-control" value={item.bookId} onChange={e => setItem(index, { bookId: e.target.value })}>
                <option value="">Select book</option>
                {books.map(book => <option key={book.id} value={book.id}>{book.title || book.name || `Book #${book.id}`}</option>)}
              </select>
              <input className="form-control" type="number" min="1" value={item.quantity} placeholder="Qty" onChange={e => setItem(index, { quantity: e.target.value })} />
              <button className="btn btn-outline-secondary" type="button" onClick={() => setItems(prev => prev.filter((_, i) => i !== index))} disabled={items.length === 1}>Remove</button>
            </div>
          ))}
          <button className="btn btn-outline-primary btn-sm" type="button" onClick={() => setItems(prev => [...prev, { ...emptyItem }])}>Add Item</button>
          <textarea className="form-control mt-3" rows="3" value={remarks} placeholder="Remarks" onChange={e => setRemarks(e.target.value)} />
          <button className="eduss-home-cta mt-3" type="submit"><FaPrint /> Create & Print QR Receipt</button>
        </form>
      </div>

      <div className="eduss-dashboard-content">
        <h2>Handover History</h2>
        <div style={{ overflowX: 'auto' }}>
          <table className="mini-info-table" style={{ width: '100%' }}>
            <thead><tr><th>Reference</th><th>School</th><th>Status</th><th>Items</th><th>Receipt</th></tr></thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.id}>
                  <td>{row.reference_no}</td>
                  <td>{row.school_id}</td>
                  <td>{row.status}</td>
                  <td>{(row.items || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0).toLocaleString()}</td>
                  <td><button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => window.open(`${apiBaseUrl}/api/v1/distribution/handovers/${row.id}/receipt`, '_blank')}><FaPrint /></button></td>
                </tr>
              ))}
              {!loading && !rows.length && <tr><td colSpan="5">No handovers yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
